import { useReactiveVar } from '@apollo/client';
import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import { useState } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import CreatePlayListContext, { type PlaylistAsset } from 'src/context/CreatePlayListContext';
import LeftSideDrawer from 'src/HomePage/DrawerAndPushedContents/LeftSideDrawer/LeftSideDrawer';
import PushedContents from 'src/HomePage/DrawerAndPushedContents/PushedContents/PushedContents';
import RightSideDrawer from 'src/HomePage/DrawerAndPushedContents/RightSideDrawer/RightSideDrawer';
import viewStateVar from 'src/store/viewState';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  hide: {
    display: 'none',
  },
  drawerHeader: {
    marginLeft: 'auto',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(0),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginTop: 0,
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
  drawerIcon: {
    position: 'fixed',
    top: 422,
    border: '1px solid rgba(255, 255, 255, 0.12)',
    padding: '4px',
  },
  homeBottomPagination: {
    margin: 'auto',
    width: 'fit-content',
    paddingBottom: 8,
    paddingTop: 8,
  },
}));

const DrawerAndPushedContents: React.FC = () => {
  const classes = useStyles();
  const viewState = useReactiveVar(viewStateVar);
  const [currentPlayList, setCurrentPlayList] = useState<number | undefined>();
  const [createAddedAssets, setCreateAddedAssets] = useState<PlaylistAsset[]>([]);

  const renderContent = (): React.ReactNode => {
    return (
      <>
        <LeftSideDrawer />
        <CreatePlayListContext.Provider
          value={{
            currentPlayList: currentPlayList ?? -1,
            setCurrentPlayList,
            createAddedAssets,
            setCreateAddedAssets,
          }}
        >
          <DndProvider backend={HTML5Backend}>
            <main
              className={clsx(classes.content, {
                [classes.contentShift]: viewState.showLeftSidebar,
              })}
            >
              <PushedContents />
            </main>
            <RightSideDrawer />
          </DndProvider>
        </CreatePlayListContext.Provider>
      </>
    );
  };

  return <div className={classes.root}>{renderContent()}</div>;
};

export default DrawerAndPushedContents;
